/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

import styled from 'styled-components';

import { colors } from '../../../theme';
import { LayoutStyled } from './Layout';

export const SeparateLineStyled = styled(LayoutStyled)`
    border-top: 1px solid ${colors.borderColorSeparateLight};
`;
